module.exports = __webpack_public_path__ + "media/src/components/PersonalAccidentInsurancePage/WhyNeedSection/3-d464154688c35e062930e40fe8824e2d.png";